/* React Imports */
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

/* CSS Imports */
import "./css/index.css";
import "./css/sidebar.css";
import "./css/searchbar.css";
import "./css/resume.css";
import "./css/articles.css";
import "./css/help.css";
import "./css/root.css";
import "./css/grids.css";
import "./css/info_button.css";

/* Route Imports */
import Root, {
  loader as rootLoader,
  action as rootAction,
} from "./routes/root";

import TestAction, { 
  action as testactionAction,
  loader as testLoader,
 } from "./routes/testaction";

import Help, {
  loader as helpLoader,
  action as helpAction,
} from "./routes/help";

import Resume, {
  loader as resumeLoader,
  action as resumeAction,
  } from "./routes/resume";

import Search, {
  loader as searchLoader,
  action as searchAction,
  } from "./routes/search";

import Restricted, {
  loader as restrictedLoader,
  action as restrictedAction,
  } from "./routes/restrictedTest";

import FlashCards, {
  loader as flashcardsLoader,
  action as flashcardsAction,
  } from "./routes/flashCards";

import ErrorPage from "./routes/error-page";

/* Begin Router */
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    loader: rootLoader,
    action: rootAction,
    children: [
      { 
        index: true,
        element: <Search/>,
        loader: searchLoader,
        action: searchAction,
        errorElement: <ErrorPage />,
      },
      {
        path: "testroute/:routeId",
        element: <TestAction/>,
        loader: testLoader,
        action: testactionAction,
        errorElement: <div>What are you doing here?</div>
      },
      {
        path: "flashcards",
        element: <FlashCards/>,
        loader: flashcardsLoader,
        action: flashcardsAction,
        errorElement: <div>What are you doing here?</div>
      },
      {
        path: "resume/",
        element: <Resume/>,
        loader: resumeLoader,
        action: resumeAction,
        errorElement: <ErrorPage />,
      },
      {
        path: "help/",
        element: <Help/>,
        loader: helpLoader,
        action: helpAction,
        errorElement: <ErrorPage />,
      },
      {
        path: "restricted/test",
        element: <Restricted/>,
        loader: restrictedLoader,
        action: restrictedAction,
        errorElement: <ErrorPage/>
      },
    ],
  }
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);